import idea1 from "../images/idea1.svg";
import foto from "../images/foto.jpg";

export const ideas = [
  {id:1,
  photo: {idea1},
   title: 'Как создать свое идеальное путешествие при помощи одного сайта?',
   text: 'Мы предлагаем новый продукт, который поможет создать каждому пользователю свое идеальное путешествие. Данный ресурс на основе машинного обучения и поддержке нейронных сетей сможет по запросу пользователя подобрать транспорт, отель и развлечения, чтобы сэкономить время и нервы на этот непростой процесс. Присоединяйся!',
   like: 123,
   dislike: 12,
   authorName: 'Petya',
   authorAvatar: {foto},
   time: '2022, 10, 15, 18, 45',
   category: ['Туристические', 'Популярное'],
  },
  {id:2,
    photo: {idea1},
  title: 'Как создать свое идеальное путешествие при помощи одного сайта?',
  text: 'Мы предлагаем новый продукт, который поможет создать каждому пользователю свое идеальное путешествие. Данный ресурс на основе машинного обучения и поддержке нейронных сетей сможет по запросу пользователя подобрать транспорт, отель и развлечения, чтобы сэкономить время и нервы на этот непростой процесс. Присоединяйся!',
  like: 123,
  dislike: 12,
  authorName: 'Petya',
  authorAvatar: {foto},
  time: '2022, 10, 15, 18, 45',
  category: ['Спортивные'],
 },
 {id:3,
  photo: {idea1},
 title: 'Как создать свое идеальное путешествие при помощи одного сайта?',
 text: 'Мы предлагаем новый продукт, который поможет создать каждому пользователю свое идеальное путешествие. Данный ресурс на основе машинного обучения и поддержке нейронных сетей сможет по запросу пользователя подобрать транспорт, отель и развлечения, чтобы сэкономить время и нервы на этот непростой процесс. Присоединяйся!',
 like: 123,
 dislike: 12,
 authorName: 'Petya',
 authorAvatar: {foto},
 time: '2022, 10, 15, 18, 45',
 category: ['Культурные', 'Популярное'],
},
{id:4,
 photo: {idea1},
title: 'Как создать свое идеальное путешествие при помощи одного сайта?',
text: 'Мы предлагаем новый продукт, который поможет создать каждому пользователю свое идеальное путешествие. Данный ресурс на основе машинного обучения и поддержке нейронных сетей сможет по запросу пользователя подобрать транспорт, отель и развлечения, чтобы сэкономить время и нервы на этот непростой процесс. Присоединяйся!',
like: 123,
dislike: 12,
authorName: 'Petya',
authorAvatar: {foto},
time: '2022, 10, 15, 18, 45',
category: ['Рекомендации'],
},
{id:5,
 photo: {idea1},
title: 'Как создать свое идеальное путешествие при помощи одного сайта?',
text: 'Мы предлагаем новый продукт, который поможет создать каждому пользователю свое идеальное путешествие. Данный ресурс на основе машинного обучения и поддержке нейронных сетей сможет по запросу пользователя подобрать транспорт, отель и развлечения, чтобы сэкономить время и нервы на этот непростой процесс. Присоединяйся!',
like: 123,
dislike: 12,
authorName: 'Petya',
authorAvatar: {foto},
time: '2022, 10, 15, 18, 45',
category: ['Технические', 'Популярное'],
}
]